import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { UpdateProvider } from "./context/UpdateContext";

import themeChakra from "./theme.js";
import PricingFeatures from "./PricingFeatures.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Use a single env variable `REACT_APP_ENV` to control rendering.
// Valid values (case-insensitive): Dev, Qa, Prod
const envRaw = process.env.REACT_APP_ENV || process.env.NODE_ENV || "";
const env = String(envRaw).toLowerCase();

let content = null;
if (env === "dev" || env === "development" || env === "qa") {
  // Development/QA: Show full app
  content = <App />;
} else if (env === "prod" || env === "production") {
  // Production: Show pricing page
} else {
  // Unknown environment: fallback to App for safety
  // To run locally, set `REACT_APP_ENV=Dev` (or Qa/Prod) before `npm start`.
  // Example: `REACT_APP_ENV=Dev npm start`
  // eslint-disable-next-line no-console
  console.warn(`Unknown REACT_APP_ENV value: '${envRaw}'. Defaulting to App.`);
  content = <PricingFeatures />;
}

root.render(
  <ChakraProvider theme={themeChakra}>
    <ColorModeScript initialColorMode={themeChakra.config.initialColorMode} />
    <BrowserRouter>
      <UpdateProvider>
        <App />
      </UpdateProvider>
    </BrowserRouter>
  </ChakraProvider>,
);

// Store a reference to the update callback that will be set by the app
let updateCallback = null;

window.__setUpdateCallback = (callback) => {
  updateCallback = callback;
};

// Register service worker for PWA functionality
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Show a notification to the user that an update is available
    if (updateCallback) {
      updateCallback(registration);
    } else {
      // Fallback if callback hasn't been set yet
      console.log("New version available!");
      if (window.confirm("New version available! Reload to update?")) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
        window.location.reload();
      }
    }
  },
  onSuccess: () => {
    console.log(
      "Service worker registered successfully. App is ready for offline use.",
    );
  },
});
